import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class ProdutosServices extends CommonService {
    constructor(http) {
        super(http);
    }

    getProdutos(page, qntd, id_empresa, range, filtro, tipo) {
        let url = `produtos/produto/${id_empresa}?tipo=${tipo}&_page=${page}&_pagesize=${qntd}`;
        // https://app.motorfiscal.com.br/teste/fornecedores/fornecedor/5b4cc42de471d50362ddce00
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return false;
            });
    }




}


// WEBPACK FOOTER //
// ./src/domain/produtos/ProdutosService.js